import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { Store } from "@ngrx/store";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFirestore } from "angularfire2/firestore";
import * as firebase from "firebase/app";
import { Observable } from "rxjs/Observable";
import { map, switchMap, take } from "rxjs/operators";
import { catchError, retry } from "rxjs/operators";
import { IClient } from "../shared/models/client.model";
import { IPushMessage } from "../shared/models/messages.model";
import { HistoryData } from "./history";
import { Utilities } from "./utilities";

@Injectable()
export class InteractivityData {
  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private Http: HttpClient,
    private store: Store<{}>,
    private afs: AngularFirestore,
    private utilities: Utilities,
  ) { }

  public getInteractivityByClient(idClient: string): any {
    return this.afDb
      .object(`/Clients/${idClient}/Interactivity`)
      .valueChanges();
  }

  public updateOpinometer(client: string, object: any): Observable<any> {
    if (object.Survey === undefined) { object.Survey = ""; }

    return Observable.fromPromise(this.afDb.database
      .ref(`Clients/${client}/Interactivity`)
      .update(object))
      .pipe(switchMap(() => {
        if (object.Survey !== undefined && object.Survey !== "") {
          return this.checkClientPollStatisticNode(client, object.Survey);
        }
        return Observable.of({});
      })).pipe(map((data) => { }));
  }

  public createClientPollStatitics(clientId: string, pollId: string): Observable<any> {
    return Observable.fromPromise(
      this.afs.firestore.collection(`${clientId}`)
        .doc("statistics")
        .collection("poll")
        .doc(`${pollId}`)
        .set({ views: 0 }),
    );
  }

  public statisticClientPollNodeExist(clientId: string, pollId: string) {
    return this.afs.collection(`${clientId}`).doc("statistics").collection("poll").doc(pollId).valueChanges();

  }

  public checkClientPollStatisticNode(clientId: string, pollId: string): Observable<any> {
    return this.statisticClientPollNodeExist(clientId, pollId)
      .pipe((switchMap((statistic) => {
        if (!statistic) {
          return this.createClientPollStatitics(clientId, pollId);
        }
        return Observable.of({});
      })),
      );
  }

  public updateModuleStateClient(
    clientId: string,
    modules: any,
  ) {
    return new Promise((res, rej) => {
      this.afDb.database
        .ref(`ClientConfig/${clientId}/modules`)
        .update(modules)
        .then(() => {
          return res(true);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public createClientMessageStatitics(clientId: string, module: string, messageId: string): Observable<any> {
    return Observable.fromPromise(
      this.afs.firestore.collection(`${clientId}`)
        .doc("messages")
        .collection(module)
        .doc(`${messageId}`)
        .set({ views: 0 }),
    );
  }

  public statisticClientMessageNodeExist(clientId: string, module: string, messageId: string) {
    return this.afs.collection(`${clientId}`).doc("messages").collection(module).doc(messageId).valueChanges();

  }

  public checkClientMessageStatisticNode(clientId: string, module: string, messageId: string) {
    return this.statisticClientMessageNodeExist(clientId, module, messageId).pipe(
      (switchMap((statistic) => {
        if (!statistic) {
          return this.createClientMessageStatitics(clientId, module, messageId);
        } else {
          return Observable.empty();
        }
      })),
    );
  }

  public createOrUpdateMessaje(
    clientId: string,
    module: string,
    object: any,
    idMessage: string = "",
  ) {
    if (!idMessage) {
      idMessage = this.afDb.createPushId();
      this.action = "create";
    }

    object.id = idMessage;

    return new Promise((res, rej) => {
      this.afDb.database
        .ref(`Clients/${clientId}/Interactivity/${module}/${idMessage}`)
        // TODO: Fix resolve .set to .update
        .set(object)
        .then(() => {
          return res(idMessage);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public createPushMessage(clientId: string, message: IPushMessage) {
    if (!message.id) {
      message.id = this.afDb.createPushId();
      this.action = "create";
    }

    return new Promise((resolve, reject) => {
      this.afDb.database
        .ref(`Clients/${clientId}/Interactivity/Push/${message.id}`)
        // TODO: Fix resolve .set to .update
        .set({ ...message, clientId })
        .then(() => {
          return resolve();
        })
        .catch((error) => {
          console.error("A big error happen");
          return reject(error);
        });
    });
  }

  public ofAllStateMessageModule(
    client: string,
    module: string,
  ) {
    return firebase
      .database()
      .ref(`Clients/${client}/Interactivity/${module}/`)
      .orderByChild("state")
      .equalTo(true)
      .once("value")
      .then((snapshot) => snapshot.forEach((childSnapshot) =>
        firebase.database().ref(`Clients/${client}/Interactivity/${module}/${childSnapshot.key}`)
          .update({ state: false }),
      ));
  }

  public transactionStateMessageModule(
    client: string,
    idMessage: string,
    module: string,
    state: boolean,
  ) {
    return firebase
      .database()
      .ref(`Clients/${client}/Interactivity/${module}/${idMessage}/state`)
      .transaction((current) => {
        return state;
      });
  }

  public sendPushMessage(clientConfig: IClient, message: IPushMessage) {
    return new Promise((resolve, reject) => {
      this.afDb.object(`Clients/${clientConfig.id}/Interactivity/Push/${message.id}/sended`).set(true)
        .then(() => {
          this.Http.post(`${ENV.backend}/notification/sendMessageToTopic`, {
            badge: clientConfig.style_image_badge,
            body: message.text[clientConfig.defaultLanguage],
            icon: clientConfig.style_image_icon,
            tag: message.id,
            title: message.title,
            topic: `/topics/${clientConfig.id}`,
            // "onclick": "www.rebus.com.co",
            // "params": `/?push_${entity.id}`,
          }).pipe(retry(3), catchError((err) => [
            this.utilities.consoleError("An error ocurred", err),
            reject(err),
          ])).subscribe((response) => {
            this.utilities.consoleDecorator("Message Sended", response);
            resolve();
          });
        });
    });
  }
}


// end file



// WEBPACK FOOTER //
// ./src/providers/interactivity.ts